import { useState } from "react";
import { api, errorText } from "@/lib/api";

export const ForgotForm = ({ onBack, initialEmail = "" }) => {
  const [email, setEmail] = useState(initialEmail);
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setBusy(true);
    try {
      const { data } = await api.post("/auth/forgot-password", { email });
      setMessage(data.message);
    } catch (err) {
      setError(errorText(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="mt-10" data-testid="forgot-form">
      <p className="font-serif text-2xl text-tinta">Olvidé mi contraseña</p>
      <p className="text-[15px] text-sec mt-2">Escribe tu correo y te mandamos un enlace para crear una contraseña nueva.</p>
      <form onSubmit={submit} className="mt-6 space-y-4">
        <label className="block" htmlFor="forgot-email">
          <span className="block text-[15px] font-medium text-tinta mb-2">Correo</span>
          <input id="forgot-email" type="email" required className="field" value={email} autoComplete="email"
            onChange={(e) => setEmail(e.target.value)} data-testid="forgot-email-input" />
        </label>
        {message && <p className="calm-note" role="status" data-testid="forgot-message">{message}</p>}
        {error && <p className="calm-note" role="status" data-testid="forgot-error">{error}</p>}
        <button type="submit" className="btn-primary w-full" disabled={busy} data-testid="forgot-submit-button">
          {busy ? "Un momento…" : "Enviar enlace"}
        </button>
      </form>
      <button type="button" className="btn-text mt-4" onClick={onBack} data-testid="forgot-back-button">Volver a entrar</button>
    </div>
  );
};
